import { useParamsSearch } from '@anytag/shared-hooks';
import { PaymentSearchSchemaType } from '../schemaTypes';

export const usePaymentsFilter = () => useParamsSearch<PaymentSearchSchemaType>();
